import React from 'react';
import Button from './Button';
import PageMessage from './PageMessage';
import Text from './Typography';

type Props = {
  illustrationClass?: string,
  title: string,
  subtitle: string,
  text: string,
  children: any,
  className: string,
  ctaText: string,
  lightText: boolean,
  onClickCTA: () => void,
  showMessage: () => PageMessage
}


const PageHeader = (props: Props) => {
  return (
    <div className={`
      page-header
      ${!props.title && !props.subtitle && !props.text && !props.children && 'no-header-content'}
      ${props.className}
    `}
    >
      <div className='container'>
        {props.showMessage && props.showMessage()}
        {props.illustrationClass && <div className={`illustration ${props.illustrationClass}`} /> }
        {props.title && <Text h1 align='center'>{props.title}</Text>}
        {props.subtitle && <Text h2 align='center' className='is-subtitle'>{props.subtitle}</Text>}
        {props.text && <Text paragraph align='center' className='is-header-text'>{props.text}</Text>}
        {props.children && (
          <div className='form'>
            {props.children}
          </div>
        )}
        {props.ctaText && props.onClickCTA && (
          <div className='is-centered'>
            <Button
              label={props.ctaText}
              onClick={props.onClickCTA}
              className='is-primary'
            />
          </div>
        )}
      </div>
      {/* can style this span to include wave if necessary
      see record-details.css for exmamples
      if header is-purple, will automatically generate a purple wave */}
      <span className='wave' />
    </div>
  );
};
export default PageHeader;




// WEBPACK FOOTER //
// ./src/components/shared/PageHeader.js